export interface IState {
  leadsList: any;
  leadsCount: number;
  leadBoatList: any;
  singleLead: any;
  boatMakeList: any;
  boatStorageContract: any;
  storagePaidAmount: any;
  storageTrasactionFee: any;
}

type Action = any;

export const leadsReducer = (
  state: IState = {
    leadsList: [],
    leadsCount: 0,
    leadBoatList: [],
    singleLead: {},
    boatMakeList: [],
    boatStorageContract: null,
    storagePaidAmount: 0,
    storageTrasactionFee: 0,
  },
  action: Action
): any => {
  switch (action.type) {
    case "GET_LEADS":
      return {
        ...state,
        leadsList: action?.payload?.page == 1 ? action?.payload?.data : [...state?.leadsList, ...action?.payload?.data],
        leadsCount: action?.payload?.count,
      };

    case "GET_LEADS_BOATS":
      return {
        ...state,
        leadBoatList: action?.payload,
      };

    case "GET_SINGLE_LEAD":
      return {
        ...state,
        singleLead: action?.payload?.data[0] ?? {},
      };
    case "GET_BOAT_STORAGE_CONTRACT":
      return {
        ...state,
        boatStorageContract: action?.payload?.data[0] ?? {},
      };

    case "UPDATE_CUSTOMER_SIGN_AFTER_APPROVE_STORAGE":
      return {
        ...state,
        boatStorageContract: {
          ...state?.boatStorageContract,
          status: 1,
          customer_action: {
            ...state?.boatStorageContract?.customer_action,
            is_signed: 1,
            signed_at: new Date(Date.now()),
            signed_url: action?.payload?.signed_url,
          },
        },
      };
    case "DELETE_LEADS":
      return {
        ...state,
        leadsList: state?.leadsList?.filter((elem: any) => elem?._id != action?.payload),
      };

    case "GET_BOAT_MAKE": {
      return {
        ...state,
        boatMakeList:
          action?.payload?.page == 1 ? action?.payload?.data : [...state?.boatMakeList, ...action?.payload?.data],
      };
    }
    case "UPDATE_BOAT_MAKE": {
      return {
        ...state,
        boatMakeList: state?.boatMakeList?.map((elem: any) => {
          if (elem?._id == action?.payload?._id) {
            return action?.payload;
          }
          return elem;
        }),
      };
    }
    case "DELETE_BOAT_MAKE":
      return {
        ...state,
        boatMakeList: state?.boatMakeList?.filter((elem: any) => elem?._id !== action?.payload),
      };
    case "OLD_STORAGE_AMOUNT_PAIDED":
      return {
        ...state,
        storagePaidAmount: action?.payload?.amount,
        storageTrasactionFee: action?.payload?.transactionFee,
      };

    case "RESTORE_AND_PERMANENT_DELETE_BOAT_MAKE":
      return {
        ...state,
        boatMakeList: state?.boatMakeList?.filter((elem: any) => elem?._id !== action?.payload),
      };
    case "ESTIMATE_CREATED_BOAT":
      return {
        ...state,
        leadBoatList: [...state?.leadBoatList, action?.payload],
      };
    case "GET_CLEAR_EMAIL_WITH_BOAT_LIST":
      return {
        ...state,
        leadBoatList: [],
      };
    case "CLEAR__LEAD_BOAT_LIST":
      return {
        ...state,
        leadBoatList: [],
      };
    default:
      return state;
  }
};
